import { render } from "./ElevatorsTable.vue?vue&type=template&id=15671a28"
import script from "./ElevatorsTable.vue?vue&type=script&lang=js"
export * from "./ElevatorsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__